import { Routes, Route, Navigate } from "react-router-dom";
import { DriverDashboardScreen } from "screens/App/CRM/Dashboard/DriverDashboardScreen";
import DriverLicenceTabs from "screens/App/CRM/Driver/driverComponents/DriverLicenceTabs";
import WorkScheduleTabs from "screens/App/CRM/Driver/driverComponents/DriverWorkSchedule";
import DriverCollectionListScreen from "screens/App/CRM/Driver/DriverCollectionListScreen";
import CollectionDetailScreen from "screens/App/CRM/Collection/CollectionDetailScreen";
import ShipmentDetailScreen from "screens/App/CRM/ShipmentRequest/ShipmentDetailScreen";
import ShipmentLoadingDetailScreen from "screens/App/CRM/ShipmentLoading/ShipmentLoadingDetailScreen";
import ShipmentUnLoadingDetailScreen from "screens/App/CRM/ShipmentUnLoading/ShipmentUnLoadingDetailScreen";
import DeliveryCreateScreen from "screens/App/CRM/ShipmentCompletion/DeliveryCreateScreen";
import DeliveryDetailScreen from "screens/App/CRM/ShipmentCompletion/DeliveryDetailScreen";
import SendOutDetailScreen from "screens/App/CRM/SendOut/SendOutDetailScreen";
import SendOutListScreenForDriver from "screens/App/CRM/SendOut/SendoutListScreenForDriver";
import { DriverSideProfile } from "screens/App/CRM/Driver/DriverSideProfile";
import DeliveryCreateScreenForDriver from "screens/App/CRM/ShipmentCompletion/DeliveryCreateScreenForDriver";
import DeliveryListScreenForDriver from "screens/App/CRM/ShipmentCompletion/DeliveryListForDriver";
import DriverShipmentLoadingListScreen from "screens/App/CRM/ShipmentLoading/DriverShipmentLoadingListScreen";
import DriverShipmentUnloadingListScreen from "screens/App/CRM/ShipmentUnLoading/DriverShipmentUnloadingListScreen";
import DriverSendOutListScreen from "screens/App/CRM/SendOut/DriverSendOutListScreen";
import DriverUnLoadingShipmentCreateScreen from "screens/App/CRM/ShipmentUnLoading/DriverUnLoadingShipmentCreateScreen";
import DriverShipmentLoadingCreateScreen from "screens/App/CRM/ShipmentLoading/ShipmentLoadingComponents/DriverShipmentLoadingCreateScreen";
import DriverShipmentUnLoadingCreateScreen from "screens/App/CRM/ShipmentUnLoading/DriverShipmentUnLoadingCreateScreen";
import DriverShipmentFreeLoadingRegularCreateScreen from "screens/App/CRM/ShipmentLoading/DriverShipmentFreeLoadingRegularCreateScreen";
import { DriverTransferScreen } from "screens/App/CRM/Driver/DriverTransferScreen";
import NotificationRouter from "./NotificationRouter";
import { DriverPartialTransferScreen } from "screens/App/CRM/Driver/PartialTransferScreenForDriver";
import { QRDriverShipmentTransferScreen } from "screens/App/CRM/Driver/QRDriverShipmentTransferScreen";

export const DriverSidebarRouter = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="dashboard" replace />} />
      <Route path="dashboard" element={<DriverDashboardScreen />} />
      <Route path="notification/*" element={<NotificationRouter />} />
      <Route path="profile" element={<DriverSideProfile />} />
      <Route path="transfer-driver" element={<DriverTransferScreen />} />
      <Route path="partial-transfer-driver" element={<DriverPartialTransferScreen />} />
      <Route path="qr-transfer-driver" element={<QRDriverShipmentTransferScreen />} />
      <Route path="licence" element={<DriverLicenceTabs />} />
      <Route path="schedule" element={<WorkScheduleTabs />} />
      <Route path="myShipments" element={<DriverCollectionListScreen />} />
      <Route path="loading" element={<DriverShipmentLoadingListScreen />} />
      <Route path="sendOut" element={<DriverSendOutListScreen />} />
      <Route path="pendingDelivery" element={<SendOutListScreenForDriver />} />
      <Route
        path="pendingDelivery/delivery"
        element={<DeliveryCreateScreenForDriver />}
      />
      <Route path="sendOut/:id/detail" element={<SendOutDetailScreen />} />
      <Route path="delivery" element={<DeliveryListScreenForDriver />} />
      <Route path="delivery/:id/detail" element={<DeliveryDetailScreen />} />
      <Route path="delivery/create" element={<DeliveryCreateScreen />} />
      <Route
        path="loading/:id/detail"
        element={<ShipmentLoadingDetailScreen />}
      />

      <Route
        path="loading/create"
        element={<DriverShipmentLoadingCreateScreen />}
      />

      {/* <Route
        path="transit-loading/create"
        element={<DriverShipmentFreeLoadingCreateScreen />}
      /> */}
      <Route
        path="destination-loading/create"
        element={<DriverShipmentFreeLoadingRegularCreateScreen />}
      />
      <Route
        path="driver-unloading/create"
        element={<DriverShipmentUnLoadingCreateScreen />}
      />

      <Route path="unloading" element={<DriverShipmentUnloadingListScreen />} />
      <Route
        path="unloading/create"
        element={<DriverUnLoadingShipmentCreateScreen />}
      />

      <Route
        path="unloading/:id/detail"
        element={<ShipmentUnLoadingDetailScreen />}
      />
      <Route
        path="collection/:id/detail"
        element={<CollectionDetailScreen />}
      />
      <Route path="shipment/:id/detail" element={<ShipmentDetailScreen />} />
    </Routes>
  );
};
